import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { APIContext } from '../../Contexts/APIContext';
import { useContext, useEffect, useState } from 'react';
import AuditHistoryViewModel from './ViewModels/AuditHistoryViewModel';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Table from '@mui/material/Table';

interface IProps {
    open: boolean;
    close: () => void;
    orgId: string;
}

export default function OfflineAuthDialog(props: IProps) {
    const { get } = useContext(APIContext);
    const [auditHistory, setAuditHistory] = useState<AuditHistoryViewModel[] | null>(null);

    useEffect(() => {
        getAuditHistory();
    }, []);

    const getAuditHistory = async () => {
        get('Organisation', `GetAuditHistory?orgId=${props.orgId}`, setAuditHistory);
    };

    return (
        <Dialog
            open={props.open}
            onClose={props.close}
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle>Audit History: {auditHistory?.at(0)?.organisationName}</DialogTitle>
            <DialogContent>
                <TableContainer>
                <Table padding="none">
                    <TableHead>
                        <TableRow>
                            <TableCell>Site Name</TableCell>
                            <TableCell>Timestamp</TableCell>
                            <TableCell>User</TableCell>
                            <TableCell>Description</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {auditHistory ? auditHistory.map((audit, index) => (
                            <TableRow key={index}>
                                <TableCell>{audit.siteName}</TableCell>
                                <TableCell>{audit.timestamp}</TableCell>
                                <TableCell>{audit.userName}</TableCell>
                                <TableCell>{audit.description}</TableCell>
                            </TableRow>
                        )) : (
                            <TableRow>
                                <TableCell colSpan={4}>Loading...</TableCell>
                            </TableRow>
                        )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
        </Dialog >
    );
}